(() => {
  if (window.AyaaniCartCrossSellV2) return;
  window.AyaaniCartCrossSellV2 = 1;

  const STRAWBERRY = 'glutathione-vitamin-c-effervescent-tablets';
  const ORANGE = 'glutathione-effervescent-tablets';
  const S_ACETYL = 's-acetyl-glutathione-300mg-high-absorption-vegan-capsules-ayaani';
  const SOFTGELS = 'antioxidant-support-glutathione-high-strength';
  const FOCUS = 'focus-nootropic-brain-cognitive-support-formula';
  const NAD = 'liposomal-nad-plus-knotweed-resveratrol';
  const CREATINE = 'creatine-gummies-5000-mg';
  const PEACH = 'ayaani-glutathione-glow-1200-mg-peach-flavour-effervescent-beauty-tablets';
  const MARINE = 'marine-collagen-beauty-powder-skin-hair-nails-gut-support';
  const GLOW_BUNDLE = 'the-glow-collection';
  const PERFORMANCE_BUNDLE = 'the-performance-stack';
  const ANTIOXIDANT_BUNDLE = 'the-antioxidant-power-pair';

  const recommendations = {
    [STRAWBERRY]: { singles: [MARINE, SOFTGELS, S_ACETYL, PEACH, ORANGE], bundle: GLOW_BUNDLE },
    [ORANGE]: { singles: [MARINE, SOFTGELS, S_ACETYL, PEACH, STRAWBERRY], bundle: GLOW_BUNDLE },
    [PEACH]: { singles: [MARINE, SOFTGELS, S_ACETYL, STRAWBERRY, ORANGE], bundle: GLOW_BUNDLE },
    [MARINE]: { singles: [PEACH, SOFTGELS, S_ACETYL, STRAWBERRY, ORANGE], bundle: GLOW_BUNDLE },
    [SOFTGELS]: { singles: [PEACH, S_ACETYL, MARINE, STRAWBERRY, ORANGE], bundle: ANTIOXIDANT_BUNDLE },
    [S_ACETYL]: { singles: [NAD, SOFTGELS, PEACH, MARINE], bundle: ANTIOXIDANT_BUNDLE },
    [FOCUS]: { singles: [CREATINE, NAD, S_ACETYL, PEACH], bundle: PERFORMANCE_BUNDLE },
    [CREATINE]: { singles: [FOCUS, NAD, S_ACETYL, PEACH], bundle: PERFORMANCE_BUNDLE },
    [NAD]: { singles: [FOCUS, S_ACETYL, CREATINE, PEACH], bundle: PERFORMANCE_BUNDLE },
    [GLOW_BUNDLE]: { singles: [S_ACETYL, STRAWBERRY, ORANGE, FOCUS] },
    [PERFORMANCE_BUNDLE]: { singles: [S_ACETYL, SOFTGELS, MARINE, PEACH] },
    [ANTIOXIDANT_BUNDLE]: { singles: [NAD, PEACH, MARINE, FOCUS] },
  };

  const fallbackSingles = [MARINE, PEACH, SOFTGELS, S_ACETYL, NAD, FOCUS, CREATINE, STRAWBERRY, ORANGE];
  const bundleHandles = new Set([GLOW_BUNDLE, PERFORMANCE_BUNDLE, ANTIOXIDANT_BUNDLE]);

  let debounceTimer;
  let observer;
  const catalog = {};

  function productHandleFromUrl(value) {
    if (!value) return '';
    try {
      const match = new URL(value, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (error) {
      const match = String(value).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }
  }

  function readCartState(drawer) {
    const present = {};
    const roots = [];
    const rootSeen = {};

    drawer.querySelectorAll('.cart-item').forEach((row) => {
      const link = row.querySelector('.cart-item__name[href*="/products/"]');
      const handle = link ? productHandleFromUrl(link.getAttribute('href')) : '';
      if (!handle) return;

      present[handle] = true;
      if (!row.classList.contains('cart-item__nested-line') && !rootSeen[handle]) {
        rootSeen[handle] = true;
        roots.push(handle);
      }
    });

    return { present, rootHandles: roots };
  }

  function createCard(item, isBundle = false) {
    const card = document.createElement('article');
    card.className = `ay-cart-cross-sell__item${isBundle ? ' ay-cart-cross-sell__item--bundle' : ''}`;

    const media = document.createElement(isBundle ? 'div' : 'a');
    media.className = 'ay-cart-cross-sell__media';
    if (!isBundle) {
      media.href = item.url;
      media.setAttribute('aria-label', `View ${item.title}`);
    }
    media.innerHTML = `<img src="${item.image}" alt="" width="90" height="90" loading="lazy">`;

    const copy = document.createElement('div');
    copy.className = 'ay-cart-cross-sell__copy';

    const name = document.createElement(isBundle ? 'span' : 'a');
    name.className = 'ay-cart-cross-sell__name';
    if (!isBundle) name.href = item.url;
    name.textContent = item.title;

    const price = document.createElement('span');
    price.className = 'ay-cart-cross-sell__price';
    price.textContent = item.price;

    copy.appendChild(name);
    copy.appendChild(price);

    const action = document.createElement('div');
    action.className = 'ay-cart-cross-sell__action';

    const button = document.createElement('button');
    button.className = 'ay-cart-cross-sell__add';
    button.type = 'button';
    button.dataset.variantId = item.variantId;
    button.textContent = 'Add to basket';

    action.appendChild(button);
    card.appendChild(media);
    card.appendChild(copy);
    card.appendChild(action);
    return card;
  }

  function eligibleSingle(handle, state, seen) {
    const item = catalog[handle];
    if (!item || !item.available || item.kind !== 'single' || state.present[handle] || seen[handle]) return null;
    seen[handle] = true;
    return item;
  }

  function selectSingles(state) {
    const selected = [];
    const seen = {};

    state.rootHandles.forEach((rootHandle) => {
      const configured = recommendations[rootHandle];
      (configured?.singles || []).forEach((handle) => {
        if (selected.length >= 2) return;
        const item = eligibleSingle(handle, state, seen);
        if (item) selected.push(item);
      });
    });

    fallbackSingles.forEach((handle) => {
      if (selected.length >= 2) return;
      const item = eligibleSingle(handle, state, seen);
      if (item) selected.push(item);
    });

    return selected;
  }

  function selectBundle(state) {
    if (state.rootHandles.some((handle) => bundleHandles.has(handle))) return null;

    const mappedBundles = [...new Set(
      state.rootHandles
        .map((handle) => recommendations[handle]?.bundle)
        .filter(Boolean),
    )];

    if (mappedBundles.length !== 1) return null;

    const item = catalog[mappedBundles[0]];
    if (!item || !item.available || item.kind !== 'bundle' || state.present[item.handle]) return null;
    return item;
  }

  function buildRecommendations(state) {
    const singles = selectSingles(state);
    const bundle = selectBundle(state);
    if (!singles.length && !bundle) return null;

    const section = document.createElement('section');
    section.className = 'ay-cart-cross-sell';
    section.dataset.signature = `${state.rootHandles.join('|')}::${Object.keys(state.present).sort().join('|')}`;
    section.setAttribute('aria-labelledby', 'AyaaniCartCrossSellTitle');
    section.innerHTML = `
      <div class="ay-cart-cross-sell__head">
        <h3 class="ay-cart-cross-sell__title" id="AyaaniCartCrossSellTitle">Goes well with</h3>
        <p class="ay-cart-cross-sell__intro">Choose the addition that best fits your routine.</p>
      </div>
    `;

    if (singles.length) {
      const items = document.createElement('div');
      items.className = 'ay-cart-cross-sell__items';
      singles.forEach((item) => items.appendChild(createCard(item)));
      section.appendChild(items);
    }

    if (bundle) {
      const heading = document.createElement('p');
      heading.className = 'ay-cart-cross-sell__bundle-heading';
      heading.textContent = 'Prefer the complete routine?';
      section.appendChild(heading);
      section.appendChild(createCard(bundle, true));
    }

    const status = document.createElement('p');
    status.className = 'ay-cart-cross-sell__status';
    status.setAttribute('aria-live', 'polite');
    section.appendChild(status);
    return section;
  }

  function render() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const drawerItems = drawer.querySelector('cart-drawer-items');
    if (!drawerItems || drawerItems.classList.contains('is-empty')) {
      drawer.querySelector('.ay-cart-cross-sell')?.remove();
      return;
    }

    const state = readCartState(drawer);
    if (!state.rootHandles.length) {
      drawer.querySelector('.ay-cart-cross-sell')?.remove();
      return;
    }

    const signature = `${state.rootHandles.join('|')}::${Object.keys(state.present).sort().join('|')}`;
    const existing = drawer.querySelector('.ay-cart-cross-sell');
    if (existing && existing.dataset.signature === signature) return;
    existing?.remove();

    const section = buildRecommendations(state);
    if (!section) return;

    const target = drawer.querySelector('#CartDrawer-CartItems')
      || drawer.querySelector('.drawer__contents.js-contents')
      || drawerItems;
    target.appendChild(section);
  }

  function scheduleRender() {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(render, 60);
  }

  async function addRecommendation(button) {
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    const section = button.closest('.ay-cart-cross-sell');
    const status = section?.querySelector('.ay-cart-cross-sell__status');
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.textContent = '';

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'This product could not be added.');
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(result);
      else window.location.href = window.routes.cart_url;
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
      if (status) status.textContent = error.message || 'This product could not be added. Please try again.';
    }
  }

  function loadCatalog() {
    const source = document.getElementById('AyaaniCartCrossSellCatalog');
    if (!source) return false;

    try {
      JSON.parse(source.textContent || '[]').forEach((item) => {
        if (item?.handle) catalog[item.handle] = item;
      });
    } catch (error) {
      console.error('Ayaani cart recommendations could not load.', error);
      return false;
    }
    return true;
  }

  function initialise() {
    if (!loadCatalog()) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    observer = new MutationObserver(scheduleRender);
    observer.observe(drawer, { childList: true, subtree: true });

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest?.('.ay-cart-cross-sell__add');
      if (addButton) {
        event.preventDefault();
        addRecommendation(addButton);
        return;
      }

      if (event.target.closest?.('#cart-icon-bubble')) window.setTimeout(render, 120);
    });

    window.addEventListener('pageshow', scheduleRender);
    scheduleRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
